// @flow
import gql from 'graphql-tag';

import RemindAPI from 'lib/RemindAPI';
import { dataIdFromObject } from 'lib/apollo/cache/memory';
import { getApolloClientSingleton } from 'lib/apollo/client/browser';
import { handleGQLError } from 'admin/actions/AutoMessageActions';
import GET_AUTO_MESSAGE_SFTP_CREDENTIALS_FOR_ORG from 'admin/components/AdminAutoMessageSftpCredentials/queries/AdminAutoMessageSftpCredentialsQuery.gql';
import EDIT_SFTP_CREDS_MUTATION from 'admin/components/AdminAutoMessageSftpCredentialsModal/queries/EditSftpCredentialsMutation.gql';
import GENERATE_SFTP_CREDS_MUTATION from 'admin/components/AdminAutoMessageSftpCredentialsModal/queries/GenerateSftpCredentialsMutation.gql';
import REVOKE_SFTP_CREDS_MUTATION from 'admin/components/AdminAutoMessageSftpCredentialsModal/queries/RevokeSftpCredentialsMutation.gql';
import EventTracking from 'lib/EventTracking';
import ToastActions from 'actions/ToastActions';

function updateCredentialsInStore(username: string, displayName: string) {
  getApolloClientSingleton().writeFragment({
    id: dataIdFromObject({ __typename: 'SftpFeatureCredentials', credentials: { username } }),
    fragment: gql`
      fragment displayNameFragment on SftpFeatureCredentials {
        displayName
      }
    `,
    data: {
      displayName,
      __typename: 'SftpFeatureCredentials',
    },
  });
}

export function generateAutoMessageSftpCredentials(
  displayName: string,
  orgUuid: string,
  onChange?: (*) => void
) {
  EventTracking.trackKey('auto_messaging.sftp_credentials.generate.click', {
    organization_uuid: orgUuid,
  });
  RemindAPI.execute({
    mutation: GENERATE_SFTP_CREDS_MUTATION,
    variables: {
      input: {
        displayName,
        orgUuid,
        featureName: 'AutoMessaging',
      },
    },
    refetchQueries: [
      {
        query: GET_AUTO_MESSAGE_SFTP_CREDENTIALS_FOR_ORG,
        variables: { orgUuid },
      },
    ],
  }).then(
    res => {
      const { error, sftpCredentials } = res.generateSftpFeatureCredentials;
      if (error) {
        handleGQLError(error, 'generateAutoMessageSftpCredentials failure');
        return;
      }
      if (onChange) {
        onChange(sftpCredentials);
      }
      ToastActions.showSuccessToast('Credentials successfully generated');
    },
    err => {
      handleGQLError(err, 'generateAutoMessageSftpCredentials failure');
    }
  );
}

export function editAutoMessageSftpCredentials(
  displayName: string,
  username: string,
  orgUuid: string,
  onChange?: () => void
) {
  RemindAPI.execute({
    mutation: EDIT_SFTP_CREDS_MUTATION,
    variables: {
      input: {
        username,
        displayName,
        orgUuid,
        featureName: 'AutoMessaging',
      },
    },
  }).then(
    res => {
      const { error } = res.editSftpFeatureCredentials;
      if (error) {
        handleGQLError(error, 'editAutoMessageSftpCredentials failure');
        return;
      }
      if (onChange) {
        onChange();
      }
      updateCredentialsInStore(username, displayName);
      ToastActions.showSuccessToast('Name successfully changed');
    },
    err => {
      handleGQLError(err, 'editAutoMessageSftpCredentials failure');
    }
  );
}

export function revokeAutoMessageSftpCredentials(
  username: string,
  orgUuid: string,
  onChange?: () => void
) {
  EventTracking.trackKey('auto_messaging.sftp_credentials.delete.click', {
    organization_uuid: orgUuid,
  });
  RemindAPI.execute({
    mutation: REVOKE_SFTP_CREDS_MUTATION,
    variables: {
      input: {
        username,
        orgUuid,
        featureName: 'AutoMessaging',
      },
    },
    refetchQueries: [
      {
        query: GET_AUTO_MESSAGE_SFTP_CREDENTIALS_FOR_ORG,
        variables: { orgUuid },
      },
    ],
  }).then(
    res => {
      const { error } = res.revokeSftpFeatureCredentials;
      if (error) {
        handleGQLError(error, 'revokeAutoMessageSftpCredentials failure');
        return;
      }
      if (onChange) {
        onChange();
      }
      ToastActions.showSuccessToast('Credentials successfully deleted');
    },
    err => {
      handleGQLError(err, 'revokeAutoMessageSftpCredentials failure');
    }
  );
}

export default {
  generateAutoMessageSftpCredentials,
  editAutoMessageSftpCredentials,
  revokeAutoMessageSftpCredentials,
};
